<template>
  <dl class="card-history">
    <dt class="card-history_heading">
      <h3 class="heading4">{{ $t('Заработано за все время:' )}}</h3>
    </dt>
    <dd>
      <ul class="moneylist" v-if="moneyAccruals.length > 0">
        <li class="moneylist_item" v-for="accrualSum in moneyAccruals" :key="accrualSum.game + accrualSum.accrualType">
          <span
            class="game-name"
            :class="'game-name__' + accrualSum.game"
            v-text="accrualSum.value ? accrualSum.value.toLocaleString('ru') : 0"
          />
        </li>
      </ul>
      <span class="card-note" v-else>Данных пока нет</span>
    </dd>

    <dt class="card-history_heading">
      <h3 class="heading4">{{ $t('Последнее зачисление:') }}</h3>
    </dt>
    <dd class="card-history_last">
      <Spinner class="card-history_spinner" size="small" color="red" v-if="loading" />
      <ul class="moneylist" v-else-if="hasLastAccrual">
        <li class="moneylist_item">
          <span
            class="game-name"
            :class="'game-name__' + lastAccrual.game"
          >
            {{ lastAccrual.accrualAmount.toLocaleString('ru') }}
          </span>
          <time class="moneylist_date" :datetime="accrualDate">
            - ({{ accrualDate | dateFormat }})
          </time>
        </li>
      </ul>
      <span class="card-history_note" v-else>Данных пока нет</span>
    </dd>
  </dl>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { VIRTUAL_CURRENCY_GROUP } from '@/constants'
import Spinner from '@/common/components/Spinner'

const accruals = namespace('accruals')

@Component({
  components: { Spinner }
})
class CardAccruals extends Vue {
  @Prop(Object) card
  @accruals.State lastCardsAccrual

  /**
   * Last virtual currency accrual by card
   * @type {Object}
   */
  get lastAccrual () {
    return this.lastCardsAccrual[this.card.cardId]
  }

  get hasLastAccrual () {
    return Object.keys(this.lastAccrual).length
  }

  get accrualDate () {
    const { accruedAt, updatedAt } = this.lastAccrual

    return accruedAt || updatedAt
  }

  get loading () {
    return !this.lastAccrual
  }

  /**
   * Virtual currencies accruals
   * @type {Array}
   */
  get moneyAccruals () {
    return this.card.accrualSums
      .filter(accrual => accrual.accrualGroup === VIRTUAL_CURRENCY_GROUP)
      .sort((a, b) => (a.value > b.value) ? -1 : 1)
  }
}

export default CardAccruals
</script>

<style lang="scss" src="./styles/card-history.scss"></style>
<style lang="scss" src="./styles/moneylist.scss"></style>
